import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Lock } from "lucide-react";

const Footer = () => {
  const links = [
    { key: "about", label: "About", to: "/about" },
    { key: "privacy", label: "Privacy Policy", to: "/privacy" },
    { key: "terms", label: "Terms of Use", to: "/terms" },
    { key: "dmca", label: "DMCA Policy", to: "/dmca" },
  ];
  return (
    <footer data-testid="app-footer" className="mt-16 border-t border-border/60">
      <div className="max-w-6xl mx-auto px-6 sm:px-10 py-8 flex flex-col sm:flex-row items-center justify-between gap-5">
        <div className="flex items-center gap-5 flex-wrap justify-center">
          {links.map((l) => (
            <Link key={l.key} to={l.to} data-testid={`footer-${l.key}`}
              className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              {l.label}
            </Link>
          ))}
        </div>

        <div data-testid="security-badge" className="flex items-center gap-2 text-xs text-muted-foreground surface rounded-full px-4 py-2">
          <ShieldCheck className="w-4 h-4 text-secondary" />
          <span>All data encrypted</span>
          <span className="text-border">·</span>
          <Lock className="w-3.5 h-3.5 gold-text" />
          <span>Addresses processed securely via Lob</span>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-6 sm:px-10 pb-6 text-center sm:text-left">
        <span className="text-[11px] text-muted-foreground/70">© {new Date().getFullYear()} GIFTED · The Relationship OS. Crafted with care.</span>
      </div>
    </footer>
  );
};

export default Footer;
